// Keep Anna navigation aligned with the passenger quote: prefer a shorter
// Google alternative only when it remains close to the fastest ETA.
export const MAX_ROUTE_DURATION_TRADEOFF_SECONDS = 3 * 60;

export const choosePreferredDrivingRoute = (routes) => {
  if (!Array.isArray(routes) || routes.length === 0) return null;

  const candidates = routes.map((route) => {
    const leg = route?.legs?.[0];
    return {
      route,
      distanceM: Number(leg?.distance?.value),
      durationS: Number(leg?.duration?.value),
    };
  }).filter((candidate) => (
    Number.isFinite(candidate.distanceM)
    && candidate.distanceM >= 0
    && Number.isFinite(candidate.durationS)
    && candidate.durationS >= 0
  ));

  if (candidates.length === 0) return routes[0];

  const fastestDurationS = Math.min(...candidates.map((candidate) => candidate.durationS));
  const comparable = candidates.filter((candidate) => (
    candidate.durationS <= fastestDurationS + MAX_ROUTE_DURATION_TRADEOFF_SECONDS
  ));

  return comparable.reduce((best, candidate) => {
    if (candidate.distanceM < best.distanceM) return candidate;
    if (candidate.distanceM === best.distanceM && candidate.durationS < best.durationS) return candidate;
    return best;
  }, comparable[0]).route;
};
